import React, { useEffect, useRef, useState } from 'react'
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import '../../DataTableDemo.css';
import { InputNumber } from 'primereact/inputnumber';
import apis from '../../api';
import './Historic.css'
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import useWindowDimensions from '../hooks/useDimensions';
import Maps from '../Maps/Maps';
import { Carousel } from 'primereact/carousel';
import Maps2 from '../Maps/Maps2';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Galleria } from 'primereact/galleria';
import { excelExport } from '../../services/excelExport.service';
import { Tooltip } from 'primereact/tooltip';
import { TablePaginator } from '../TablePaginator/TablePaginator';

const Historic = () => {

    const [fechaInicioConsulta, setFechaInicioConsulta] = useState("")
    const [fechaFinConsulta, setFechaFinConsulta] = useState("")
    const [estado, setEstado] = useState("")
    const [contrato, setContrato] = useState("")

    const [idSolicitud, setIdSolicitud] = useState("")
    const [tipo, setTipo] = useState("")
    const [consolidado, setConsolidado] = useState("")
    const [diasTiempo, setDiasTiempo] = useState("")
    const [diasDinero, setDiasDinero] = useState("")
    const [fechaInicio, setFechaInicio] = useState("")
    const [fechaFin, setFechaFin] = useState("")

    const [fechaInicioAusentismo, setFechaInicioAusentismo] = useState("")
    const [fechaFinAusentismo, setFechaFinAusentismo] = useState("")
    const [contingencia, setContingencia] = useState("")
    const [tiempo, setTiempo] = useState("")
    const [observaciones, setObservaciones] = useState("")
    const [adjunto, setAdjunto] = useState("")

    const [longitud, setLongitud] = useState(0)
    const [latitud, setLatitud] = useState(0)
    const [trackFotos, setTrackFotos] = useState([])
    const [trackInfo, setTrackInfo] = useState({})
    const [trackDescription, setTrackDescription] = useState("")

    const [listaTipo, setListaTipo] = useState([])
    const [listaContingencia, setListaContingencia] = useState([])
    const [listaEstados, setListaEstados] = useState([])
    const [listaContratos, setListaContratos] = useState([])

    const toast = useRef(null);
    const elementWidth = { width: "12rem" }
    const labelStyle = {
        display: "block",
        float: "left",
        marginTop: "5px",
        width: "100%",
        paddingTop: "5px"
    }

    const { width } = useWindowDimensions()

    const headers = {
        authorization: localStorage.getItem('token')
    }

    const [isOpenD, setIsOpenD] = useState(false)

    const [isOpenMapa, setIsOpenMapa] = useState(false)

    const [loading, setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [loadPage, setLoadPage] = useState(false)

    const [rows, setRows] = useState([]);
    const [exportRows, setExportRows] = useState([])
    const [products, setProducts] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(5);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const [clientList, setClientList] = useState([])
    const [entityList, setEntityList] = useState([])
    const [client, setClient] = useState("")
    const [entity, setEntity] = useState("")
    const [selectedRows, setSelectedRows] = useState([])
    const [fullExportRows, setFullExportRows] = useState([])

    const containerStyles = {
        display: 'block',
        maxWidth: '200px',
        // maxHeight: '200px',
        width: 'auto',
        height: 'auto'
    };

    const imgStyles = {
        width: '100%',
        height: '100%',
    };

    const responsiveOptions = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '575px',
            numVisible: 1
        }
    ];

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    useEffect(() => {
        const template = async () => {
            if (window.location.href.indexOf('/HistoricEmployees') === -1) {
                await apis.getRequestList(localStorage.getItem('entity'), localStorage.getItem('client'), localStorage.getItem('contract_id'), headers).then(res => {
                    let tipos = res.data.TYPE_NOVELTIES
                    let estados = res.data["ESTADOS MODULOS"]
                    let _consolidado = res.data.DAY_CSO
                    setListaTipo(tipos)
                    setListaEstados(estados)
                    setConsolidado(_consolidado)
                    setLoadPage(true)
                })
            }
            else {
                await apis.getPendRequests(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                    let tipos = res.data.TYPE_NOVELTIES
                    let estados = res.data["ESTADOS MODULOS"]
                    let contratos = res.data["CONTRACTS"]
                    setListaTipo(tipos)
                    setListaEstados(estados)
                    setListaContratos(contratos)
                    setLoadPage(true)
                })
            }
        }
        template()
    }, [])

    useEffect(() => {
        setRows([])
    }, [window.location.pathname])

    const showModalD = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenD(true);
    };

    const hideModalD = () => {
        setIsOpenD(false);
        setAdjunto("")
    };

    const showModalMapa = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenMapa(true);
    };

    const hideModalMapa = () => {
        setIsOpenMapa()
    };

    //Evento para cambiar de pagina
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }
    //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
    const template2 = TablePaginator()

    const applyFilters = (entity_, client_) => {
        let filtered = [...selectedRows]

        let filteredExport = [...fullExportRows]
    
        if (entity_) {
            filtered = filtered.filter(row => row.ENTITY === entity_.CODE);
            filteredExport = filteredExport.filter(row => row.Empresa === entity_.CODE);
        }
    
        if (client_) {
            filtered = filtered.filter(row => row.CLIENT === client_.CODE);
            filteredExport = filteredExport.filter(row => row.Cliente === client_.CODE);
        }
        setExportRows(filteredExport)
        setRows(filtered);
    };

    const filterByEntity = (entity_) => {
        setEntity(entity_);
        setClient("")
        setClientList(entity_?.CLIENTS ? entity_.CLIENTS : [])
        applyFilters(entity_, entity_  ? client : undefined);
    };

    const filterByClient = (client_) => {
        setClient(client_);
        applyFilters(entity, client_ ? client_ : undefined);
    };

    //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
    const actionBodyTemplate = (rowData) => {
        return (
            <div className='flex flex-row'>
                <Button icon="pi pi-align-justify" className="p-button-warning mr-2 p-button-sm text-xs" onClick={() => { initializeData(rowData); getRequestDetail(rowData.REQUESTS_ID) }} tooltip="Detalle" />
            </div>
        )
    }

    //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
    const renderHeader1 = () => {
        const msg = "Para filtrar la información, seleccione una empresa.\n Esto habilitará los clientes pertenecientes a dicha empresa\n y se podrá realizar el filtro por ambos campos"
        const headerClassname = 'flex align-items-center align-content-center gap-2 ' + (width > 768 ? 'flex-row' : 'flex-column')
        return (
            <div className="barra">
                <div className={headerClassname}>
                    <Tooltip target=".info" className='indigo-tooltip ml-1'/>
                    <div className='flex flex-row align-items-center gap-1'>
                        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
                        <i className="info pi pi-info-circle cursor-pointer" data-pr-tooltip={msg} data-pr-position='bottom'
                            data-pr-classname="text-primary" style={{ color: '#00a8ff', fontSize: '1.2rem' }} />
                    </div>
                    <Dropdown value={entity} options={entityList} onChange={(e) => filterByEntity(e.value)} optionLabel="NAME" showClear disabled={entityList.length === 0}
                        placeholder="Empresa" style={{ width: '12rem' }} tooltip={entity?.NAME} tooltipOptions={{position: 'top'}}/>
                    <Dropdown value={client} options={clientList} onChange={(e) => filterByClient(e.value)} optionLabel="NAME" showClear disabled={!entity}
                        placeholder="Cliente" style={{ width: '12rem' }} tooltip={client?.NAME} tooltipOptions={{position: 'top'}}/>
                </div>
                <IconField iconPosition="left" style={{marginTop: width <= 768 && '0.5rem'}}>
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
                </IconField>
            </div>
        )
    }

    //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    //Limpiar e inicializar los filtros
    const clearFilter1 = () => {
        initFilters1();
        setEntity("")
        setClient("")
        setRows(selectedRows)
        setExportRows(fullExportRows)
    }

    //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
    const header1 = renderHeader1();

    //Limpiar filtros de la tabla
    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'REQUESTS_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NOVELTY': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CONTRACT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'UNITY': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'TIME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    //Nombre de las opciciones para los filtros
    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    async function initializeData(row) {
        setIdSolicitud(row.REQUESTS_ID)
        setTipo(row.NOVELTY_ID)
    }

    const setTabla = async () => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _contract = window.location.href.indexOf('/HistoricEmployees') === -1 ? localStorage.getItem('contract_id') : (contrato ? contrato.CODE : 'NULL')
        const _estado = estado ? estado.detail_id : "NULL"
        const _fechaInicio = fechaInicioConsulta ? dateFormat(fechaInicioConsulta) : "NULL"
        const _fechaFin = fechaFinConsulta ? dateFormat(fechaFinConsulta) : "NULL"

        try {
            await apis.getAllRequests(_entity, _client, _estado, _contract, _fechaInicio, _fechaFin, headers).then(res => {
                if (res.data.NOVELTIES.length > 0) {
                    let data = res.data.NOVELTIES
                    let solicitudes = []
                    let entity_list = []
                    let client_list = []
                    let exportRows = []
                    data.forEach(element => {
                        let registro = element
                        let solicitud = registro.NOVELTY.split("|")
                        let contrato = registro.CONTRACT_ID.split("|")
                        let estado = registro.STATUS.split("|")
                        let idSolicitud = solicitud[0]
                        let idContrato = contrato[0]
                        let idEstado = estado[0]
                        solicitud = solicitud[1]
                        contrato = contrato[1]
                        estado = estado[1]
                        registro.NOVELTY = solicitud
                        registro.CONTRACT_ID = idContrato
                        registro.STATUS = estado
                        registro = {
                            ...registro,
                            NOVELTY_ID: idSolicitud,
                            CONTRACT: contrato,
                            STATUS_ID: idEstado
                        }
                        let exportRow = {
                            'Id solicitud': registro.REQUESTS_ID,
                            'Tipo solicitud': solicitud,
                            Contrato: idContrato,
                            Nombre: contrato,
                            Empresa: registro.ENTITY,
                            Cliente: registro.CLIENT,
                            'Nombre empresa': registro.ENTITY_NAME,
                            'Nombre cliente': registro.CLIENT_NAME,
                            'Fecha inicio': registro.START_DATE,
                            'Días': registro.UNITY,
                            'Fecha fin': registro.END_DATE,
                            'Marcación': registro.TYPE ? registro.TYPE : "",
                            'Hora': registro.TIME ? registro.TIME : "",
                            Estado: estado
                        }
                        let entityIndex = entity_list.findIndex(ent => ent.CODE === element.ENTITY)
                        if(entityIndex !== -1){
                            let ent = entity_list[entityIndex]
                            let clients = [...ent.CLIENTS]
                            if(!ent.CLIENTS.some(cli => cli.CODE === element.CLIENT)){
                                let newClient = {
                                    CODE: element.CLIENT,
                                    NAME: element.CLIENT_NAME
                                }
                                clients.push(newClient)
                            }
                            ent = {
                                ...ent,
                                CLIENTS: [...clients]
                            }
                            entity_list[entityIndex] = ent
                        }
                        else{
                            let newClient = {
                                CODE: element.CLIENT,
                                NAME: element.CLIENT_NAME
                            }
                            let newEntity = {
                                CODE: element.ENTITY,
                                NAME: element.ENTITY_NAME,
                                CLIENTS: [newClient]
                            }
                            entity_list.push(newEntity)
                        }
                        solicitudes.push(registro)
                        exportRows.push(exportRow)
                    });
                    setRows(solicitudes)
                    setSelectedRows(solicitudes)
                    setExportRows(exportRows)
                    setClientList(client_list)
                    setEntityList(entity_list)
                    setFullExportRows(exportRows)
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Consulta exitosa" })
                }
                else {
                    setRows([])
                    setExportRows([])
                    setSelectedRows([])
                    setFullExportRows([])
                    toast.current.show({ severity: 'warn', summary: 'Éxito', detail: "Consulta sin resultados" })
                }
                setLoading(false)
            })
        }
        catch (err) {
            setRows([])
            setExportRows([])
            setSelectedRows([])
            setFullExportRows([])
            setLoading(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const getRequestDetail = async (id) => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')

        try {
            await apis.getRequest(_entity, _client, id, headers).then(res => {
                let solicitud = res.data
                let tipo = solicitud.NOVELTY.split("|")
                if (tipo[0] === "VAC") {
                    setConsolidado(solicitud.DAY_CSO)
                    setDiasDinero(solicitud.DAYS_DIN)
                    setDiasTiempo(solicitud.DAYS_TIE)
                    setFechaInicio(invDateFormat(solicitud.START_DATE))
                    setFechaFin(invDateFormat(solicitud.END_DATE))
                    if (solicitud.FILES && solicitud.FILES.length > 0) {
                        let adjuntos = solicitud.FILES[0]
                        setAdjunto(adjuntos)
                    }
                }
                else if (tipo[0] === "ABS") {
                    let _contingencia = solicitud.CONTINGENCY.split("|")
                    setFechaInicioAusentismo(invDateFormat(solicitud.START_DATE))
                    setFechaFinAusentismo(invDateFormat(solicitud.END_DATE))
                    setContingencia({ CODE: _contingencia[0], TYPE: _contingencia[0], NAME: _contingencia[1] })
                    setTiempo(solicitud.DAYS)
                    setObservaciones(solicitud.OBSERVATIONS)
                    if (solicitud.FILES && solicitud.FILES.length > 0) {
                        let adjuntos = solicitud.FILES[0]
                        setAdjunto(adjuntos)
                    }
                }
                else if (tipo[0] === "TRK") {
                    console.log(solicitud)
                    let location = solicitud.GEOLOCATION
                    let imagenes = {
                        ICON: solicitud.IMAGES ? solicitud.IMAGES : "",
                        DETAIL: solicitud.FILES ? solicitud.FILES : []
                    }
                    let info = {
                        DATE: solicitud.DATE ? solicitud.DATE : "",
                        TIME: solicitud.TIME ? solicitud.TIME : "",
                        TYPE: solicitud.TYPE ? solicitud.TYPE : "",
                        STATUS: solicitud.STATUS ? solicitud.STATUS : "",
                        NUMBER_ID: solicitud.NUMBER_ID
                    }
                    setLongitud(parseFloat(location.LON))
                    setLatitud(parseFloat(location.LAT))
                    setTrackDescription(solicitud.CONTRACT_ID)
                    setTrackFotos(imagenes)
                    setTrackInfo({
                        ...trackInfo,
                        ...info
                    })
                }
                else if (tipo[0] === "TURN") {
                    let location = solicitud.GEOLOCATION
                    location[0]["LAT"] = parseFloat(location[0]["LAT"])
                    location[0]["LON"] = parseFloat(location[0]["LON"])
                    location[1]["LAT"] = parseFloat(location[1]["LAT"])
                    location[1]["LON"] = parseFloat(location[1]["LON"])
                    let imagenes = {
                        ICON: solicitud.IMAGES ? solicitud.IMAGES : "",
                        DETAIL: solicitud.FILES ? solicitud.FILES : []
                    }
                    let info = {
                        DATE_IN: solicitud.DATE_IN ? solicitud.DATE_IN : "",
                        DATE_OUT: solicitud.DATE_OUT ? solicitud.DATE_OUT : "",
                        TIME_IN: solicitud.TIME_IN ? solicitud.TIME_IN : "",
                        TIME_OUT: solicitud.TIME_OUT ? solicitud.TIME_OUT : "",
                        STATUS: solicitud.STATUS ? solicitud.STATUS : "",
                        NUMBER_ID: solicitud.NUMBER_ID
                    }
                    setLongitud([location[0]['LON'], location[1]['LON']])
                    setLatitud([location[0]['LAT'], location[1]['LAT']])
                    setTrackDescription(solicitud.CONTRACT_ID)
                    setTrackFotos([imagenes, imagenes])
                    setTrackInfo({
                        ...trackInfo,
                        ...info
                    })
                }
            })
            showModalD()
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const exportExcel = () => {
        try{
            excelExport(exportRows, 'HistóricoDeSolicitudes')
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Información exportada exitosamente" })
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Error al exportar información', sticky: true });
        }
        finally{
            setLoading2(false)
        }
    }

    const saveAsExcelFile = (buffer, fileName) => {
        /*Función encargada de guardar y descargar el archivo Excel de la plantilla*/
        import('file-saver').then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.default.saveAs(data, fileName + EXCEL_EXTENSION);
        });
    }

    const selectItemTemplate = (option) => {
        return (
            <div className="flex jsutify-content-start align-items-center">
                <img alt={""} src={option.IMAGES} width={50} height={50} style={{ verticalAlign: 'middle', borderRadius: '40px' }} />
                &nbsp;
                &nbsp;
                &nbsp;
                <span>{option.CODE} - {option.NAME}</span>
            </div>
        );
    };


    const leftToolbarTemplate = () => {
        const leftClassName = 'flex align-content-center gap-2 ' + (width > 768 ? 'flex-row' : 'flex-column')
        return (
            <div className={leftClassName}>
                {window.location.href.indexOf('/HistoricEmployees') !== -1 &&
                    <Dropdown value={contrato} autofocus optionLabel='NAME' itemTemplate={selectItemTemplate}
                        filter showClear filterBy="NAME,CODE" emptyMessage={"No hay contratos disponibles"}
                        onChange={(e) => setContrato(e.value)} options={listaContratos} placeholder="Contrato" />}
                <Dropdown value={estado} autofocus optionLabel='description'
                    filter showClear filterBy="description" emptyMessage={"No hay estados disponibles"}
                    onChange={(e) => setEstado(e.value)} options={listaEstados} placeholder="Estado*" />
                <Calendar id="navigators" value={fechaInicioConsulta} onChange={(e) => setFechaInicioConsulta(e.value)} locale="es"
                    dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
                    placeholder="Fecha inicio"
                />
                <Calendar id="navigators" value={fechaFinConsulta} onChange={(e) => setFechaFinConsulta(e.value)} locale="es"
                    dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
                    placeholder="Fecha fin"
                />
            </div>
        )
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button loading={loading} label="Consultar" icon="pi pi-search" disabled={!estado} className=" mr-2 p-button-sm" onClick={() => { setLoading(true); setTabla() }} />
                {window.location.href.indexOf('/HistoricEmployees') !== -1 &&
                    <Button disabled={exportRows.length < 1} loading={loading2} label="Exportar" icon="pi pi-file-excel" className=" mr-2 p-button-sm p-button-success"
                        onClick={() => { setLoading2(true); exportExcel() }} />}
            </React.Fragment>
        )
    }

    const detailHeader = (
        <div>
            <h3>Detalle solicitud</h3>
        </div>
    );

    const itemTemplate = (item) => {
        return <img src={item.URL ? item.URL : item} alt={item.NAME_FILE ? item.NAME_FILE : 'photo'} style={{ width: '100%', display: 'block', maxHeight: '50vh', 
            height: 'auto', objectFit: 'contain', display: 'block' }} />;
    }

    const thumbnailTemplate = (item) => {
        return <img src={item.URL ? item.URL : item} alt={item.NAME_FILE ? item.NAME_FILE : 'photo'} style={{ display: 'block', maxHeight: "100px", maxWidth: "150px" }} />;
    }

    const header = <div className='flex justify-content-center mt-2'>
        <h4>Entrada y salida de la novedad</h4>
    </div>

    const buttonStyle = {
        overflow: "hidden",
        maxWidth: "20rem"
    }

    return (
        <div className='surface-100 px-4 py-5 md:px-6 lg:px-8'>
            <Dialog header={detailHeader} visible={isOpenD} position="top" style={tipo !== "TRK" ? { width: "26rem" } : { width: width > 768 ? "70vw" : "95vw" , height: "90vh" }}
                draggable={false} resizable={false} modal onHide={hideModalD}>
                {tipo === "VAC" ? <><label style={labelStyle} htmlFor="label">Dias consolidado</label>
                    <InputNumber min={0} value={consolidado} placeholder="Dias consolidado" disabled={true} />
                    <label style={labelStyle} htmlFor="label">Dias tiempo</label>
                    <InputNumber min={0} value={diasTiempo} placeholder="Dias tiempo" disabled={true} />
                    <label style={labelStyle} htmlFor="label">Dias Dinero</label>
                    <InputNumber min={0} value={diasDinero} placeholder="Dias Dinero" disabled={true} />
                    <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                    <Calendar id="navigators" value={fechaInicio} locale="es"
                        dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon disabled={true}
                    />
                    <label style={labelStyle} htmlFor="label">Fecha fin</label>
                    <Calendar id="navigators" value={fechaFin} locale="es" dateFormat="dd-mm-yy"
                        yearRange="2010:2030" disabled={true} showIcon />
                    {adjunto &&
                        <>
                            <label style={labelStyle} htmlFor="label">Adjunto</label>
                            <Button className='file-btn' style={buttonStyle} label={width > 426 ? adjunto.NAME_FILE + "." + adjunto.TYPE_FILE : ""} icon="pi pi-download"
                                onClick={() => window.location.href = adjunto.URL} tooltip={adjunto.NAME_FILE + "." + adjunto.TYPE_FILE} tooltipOptions={{ position: 'bottom' }} />
                        </>
                    }</>
                    : tipo === "ABS" ?
                        <div className='flex flex-column'>
                            <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                            <Calendar id="navigators" value={fechaInicioAusentismo} disabled={true} locale="es"
                                dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
                            />
                            <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                            <Calendar id="navigators" value={fechaFinAusentismo} locale="es"
                                dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon disabled={true}
                            />
                            <label style={labelStyle} htmlFor="label">Contingencia</label>
                            <Dropdown value={contingencia} autofocus optionLabel='NAME'
                                filter showClear filterBy="NAME" emptyMessage={"No hay tipos disponibles"}
                                disabled={true} options={listaContingencia} placeholder={contingencia ? contingencia.NAME : 'Seleccione'} />
                            <label style={labelStyle} htmlFor="label">Tiempo</label>
                            <InputNumber min={0} value={tiempo} placeholder="Tiempo" disabled={true} />
                            <label style={labelStyle} htmlFor="label">Observaciones</label>
                            <InputTextarea maxLength={70} value={observaciones} disabled={true} rows={4} cols={30} />
                            {adjunto &&
                                <>
                                    <label style={labelStyle} htmlFor="label">Adjunto</label>
                                    <Button className='file-btn' style={buttonStyle} label={width > 426 ? adjunto.NAME_FILE + "." + adjunto.TYPE_FILE : ""} icon="pi pi-download"
                                        onClick={() => window.location.href = adjunto.URL} tooltip={adjunto.NAME_FILE + "." + adjunto.TYPE_FILE} tooltipOptions={{ position: 'bottom' }} />
                                </>
                            }
                        </div>
                        : tipo === 'TRK' ?
                            <>
                                <Maps2 latitud={[latitud]} longitud={[longitud]} descripcion={[trackDescription]} icon={[trackFotos]} info={[trackInfo]} />
                                {/* <div className="carousel-demo2">
                                <Carousel value={trackFotos} numVisible={1} numScroll={1} itemTemplate={itemTemplate} header={header} className="custom-carousel" />
                            </div> */}
                            </>
                            :
                            <>
                                <label className='font-bold' style={labelStyle} htmlFor="label">Ingreso:</label>
                                <span className='font-bold'>Fecha: </span>
                                <span>{trackInfo.DATE_IN} </span>
                                <span className='font-bold'>Hora: </span>
                                <span>{trackInfo.TIME_IN} </span><br />
                                <label className='font-bold' style={labelStyle} htmlFor="label">Salida:</label>
                                <span className='font-bold'>Fecha: </span>
                                <span>{trackInfo.DATE_OUT} </span>
                                <span className='font-bold'>Hora: </span>
                                <span>{trackInfo.TIME_OUT}</span><br /><br />
                                <Button label='Ver ubicación' icon='pi pi-eye' size='small' onClick={showModalMapa} /><br /><br />
                                {trackFotos[0] && trackFotos[0].DETAIL && trackFotos[0].DETAIL.length > 0 &&
                                    <div>
                                        <Galleria value={trackFotos[0].DETAIL} responsiveOptions={responsiveOptions} numVisible={5} style={{ maxWidth: '640px' }}
                                            item={itemTemplate} thumbnail={thumbnailTemplate} />
                                    </div>}
                            </>
                }
            </Dialog>
            <Dialog visible={isOpenMapa} draggable={false} resizable={false} modal onHide={hideModalMapa} style={{ width: width > 768 ? "70vw" : "95vw" , height: "90vh" }}>
                <Maps2 latitud={latitud} longitud={longitud} descripcion={[]} icon={trackFotos} info={[trackInfo]} />
            </Dialog>
            <Toast ref={toast} />
            <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
                <span className="text-900">Histórico solicitudes {window.location.href.indexOf('/HistoricEmployees') !== -1 && ' de empleados'}</span>
            </div>
            <span>Campos obligatorios (*)</span>
            <div className="mt-6">
                <SkeletonTable load={loadPage}>
                    <Toolbar className='card flex flex-row cosa'start={leftToolbarTemplate} end={rightToolbarTemplate} />
                    <DataTable className="card text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                        selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="REQUESTS_ID"
                        size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['REQUESTS_ID', 'NOVELTY', 'CONTRACT_ID', 'CONTRACT',
                            'START_DATE', 'UNITY', 'END_DATE', 'TYPE', 'TIME', 'STATUS']}
                        header={header1}>
                        <Column field="REQUESTS_ID" header="Id solicitud" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por id" sortable></Column>
                        <Column field="NOVELTY" header="Tipo solicitud" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tipo" sortable></Column>
                        <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
                        <Column field="CONTRACT" header="Nombre" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por nombre" sortable></Column>
                        <Column field="ENTITY_NAME" header="Empresa" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por empresa" sortable></Column>
                        <Column field="CLIENT_NAME" header="Cliente" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por cliente" sortable></Column>
                        <Column field="START_DATE" header="Feha inicio" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha inicio" sortable></Column>
                        <Column field="UNITY" header="Dias" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por días" sortable></Column>
                        <Column field="END_DATE" header="Feha fin" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha fin" sortable></Column>
                        <Column field="TYPE" header="Marcación" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por marcación" sortable></Column>
                        <Column field="TIME" header="Hora" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por hora" sortable></Column>
                        <Column field="STATUS" header="Estado" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por estado" sortable></Column>
                        <Column headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
                    </DataTable>
                </SkeletonTable>
            </div>
        </div>
    )
}

export default Historic